export default __webpack_public_path__ + "static/media/team-2.e725aef8.jpg";